module.exports = __webpack_public_path__ + "img/nodata-check.e0ab9205.png";